module.exports = __webpack_public_path__ + "img/timeline.579abdd5.svg";